import { Box, Spinner, Tag, TagLabel, TagLeftIcon } from "@chakra-ui/react";
import React from "react";
import { IconType } from "react-icons";
import { Glossary } from "../Text/Glossary";

interface StatusTagProps {
  status: StatusTagMetadata;
  variant?: "long" | "short";
  customLabel?: string | undefined;
  isLoading?: boolean;
  disableGlossary?: boolean;
}

export interface StatusTagMetadata {
  label: string;
  longLabel: string;
  icon?: IconType;
  variant?: string;
  colorScheme: string;
}

export const StatusTag: React.FC<StatusTagProps> = ({
  status,
  variant = "short",
  customLabel: label = undefined,
  isLoading = false,
  disableGlossary = false,
}) => {
  if (!label) {
    switch (variant) {
      case "long":
        label = status.longLabel;
        break;
      case "short":
        label = status.label;
        break;
    }
  }
  return (
    <Box display="flex" alignItems="flex-start">
      <Tag
        colorScheme={status.colorScheme}
        borderRadius="md"
        fontSize="xs"
        variant={status.variant ?? "subtle"}
      >
        {isLoading ? (
          <Spinner size="xs" marginInlineEnd={1} flexShrink={0} />
        ) : (
          status.icon && <TagLeftIcon aria-hidden={true} as={status.icon} />
        )}
        <TagLabel>
          {disableGlossary ? label : <Glossary>{label}</Glossary>}
        </TagLabel>
      </Tag>
    </Box>
  );
};
